export default __webpack_public_path__ + "static/media/custom-reports-guide-create-add.a8954543.png";